import get from 'lodash/get.js';

import BaseInterceptor from '@/router/interceptors/BaseInterceptor.js';
import ImpersonationExpiryMonitor from '@/services/ImpersonationExpiryMonitor.js';
import loadingService from '@/services/LoadingService.js';

class AccessDeniedInterceptor extends BaseInterceptor {
    handle(status, error) {
        // Concurrent requests can 403 after impersonation is force-stopped
        // server-side; don't flash the 403 page while the expiry redirect runs.
        if (ImpersonationExpiryMonitor.isRedirectInProgress()) {
            return;
        }

        const routeMatch = ['/login'].includes(this.$router.currentRoute.value.path);

        if ((status === 403 || status === 412) && !routeMatch) {
            if (this.$router.currentRoute.value.name !== '403' && get(error.config, 'errorHandle') !== false) {
                loadingService.closeAll();

                this.$router.push({
                    name: '403',
                    params: {
                        message: get(error, 'response.data.message'),
                        exception: get(error, 'response.data.exception'),
                        meta: get(error, 'response.meta'),
                    },
                });
            }
        }
    }
}

export default AccessDeniedInterceptor;
